// extracted by mini-css-extract-plugin
export default {"dropDown":"Ss_1KcLNBt-4PUwKM8k9w","dropDownLabel":"_12Oa3ZkWkR6LPCvezHLQsg"};